import React from 'react';
import Moment from 'moment';
import Header, {headerQuery} from '../components/new-ui/header';
import {Redirect, Route, Switch} from 'react-router-dom';
import AppV2, {appv2Query} from './appv2';
import AccessBlocked, {accessBlockedQuery} from './access_blocked';
import AppAsana, {appAsanaQuery} from './settings/app_catalog/app_asana';
import AppAzureActiveDirectory, {appAzureActiveDirectoryQuery} from './settings/app_catalog/app_azure_active_directory';
import AppGoSimplo from './settings/app_catalog/AppGoSimplo';
import AppBambooHR, {appBambooHRQuery} from './settings/app_catalog/AppBambooHR';
import AppCalendar, {appCalendarQuery} from './settings/app_catalog/app_calendar';
import AppEconomic, {appEconomicQuery} from './settings/app_catalog/app_economic';
import AppGithub, {appGithubQuery} from './settings/app_catalog/app_github';
import AppGitlab, {appGitlabQuery} from './settings/app_catalog/app_gitlab';
import AppGoogleDrive, {appGoogleDriveQuery} from './settings/app_catalog/app_google_drive';
import AppHarvest, {appHarvestQuery} from './settings/app_catalog/app_harvest';
import AppJira, {appJiraQuery} from './settings/app_catalog/app_jira';
import AppJiraServer, {appJiraServerQuery} from './settings/app_catalog/app_jira_server';
import AppOkta, {appOktaQuery} from './settings/app_catalog/app_okta';
import AppOnelogin, {appOneloginQuery} from './settings/app_catalog/app_onelogin';
import AppQuickbooks, {appQuickbooksQuery} from './settings/app_catalog/app_quickbooks';
import AppUnit4, {appUnit4Query} from './settings/app_catalog/app_unit4';
import AppSlack, {appSlackQuery} from './settings/app_catalog/app_slack';
import AppTimeLog, {appTimelogQuery} from './settings/app_catalog/app_timelog';
import AppTrello, {appTrelloQuery} from './settings/app_catalog/app_trello';
import AppVsts, {appVstsQuery} from './settings/app_catalog/app_vsts';
import AppXero, {appXeroQuery} from './settings/app_catalog/app_xero';
import AppTeams, {appTeamsQuery} from './settings/app_catalog/app_teams';
import AppZapier from './settings/app_catalog/app_zapier';
import CanvasScheduling from '../components/canvas-scheduling/canvas_scheduling';
import CompanyStats, {companyStatsQuery} from './internal/company_stats';
import Flatfile, {FlatfileQuery} from './internal/Flatfile';
import MLStats, {mlStatsQuery} from './internal/ml_stats';
import ControlPersonList, {controlPersonListQuery} from './internal/control_person_list';
import FeatureFlags, {featureFlagsQuery} from './internal/feature_flags';
import GenericSavedReportConductor, {
	genericSavedReportConductorQuery,
} from '../components/insights/generic_saved_report_conductor';
import FinancialReportPage, {
	financialReportPageQuery,
} from '../components/insights/financial-portfolio-report/financial_report_page';
import FirstLogin, {firstLoginQuery} from './first_login';
import FirstLoginV2, {firstLoginV2Query} from './first_login_v2';
import ForgotPassword from './forgot_password';
import GlobalSearchResultsPage, {globalSearchResultsPageQuery} from './global_search_results_page';
import Impersonate, {impersonateQuery} from './internal/impersonate';
import InsightsBuilderV2, {insightsBuilderV2Query} from './insights/insights_builder_v2';
import InsightsSection, {insightsSectionQuery} from './insights/insights_section';
import InsightsViewer, {insightsViewerQuery} from './insights/insights_viewer';
import Login, {loginQuery} from './login';
import LoginAzureActiveDirectory, {loginAzureActiveDirectoryQuery} from './login_azure_active_directory';
import LoginOauth, {loginOauthQuery} from './login_oauth';
import LoginOkta, {loginOktaQuery} from './login_okta';
import LoginOnelogin, {loginOneloginQuery} from './login_onelogin';
import LoginSalesforce, {loginSalesforceQuery} from './login_salesforce';
import Maintenance, {maintenanceQuery} from './maintenance';
import MyExpenses, {myExpensesQuery} from './my_profile/my_expenses';
import MyWorkPageV2, {MyWorkPageV2Query} from '../forecast-app/my-work-tab/my-tasks-page/MyWorkPageV2';
import MyTaskActivities, {myTaskActivitiesQuery} from './my_profile/my_task_activities';
import NewInsightContainer, {newInsightQuery} from './insights/new_insight/new_insight';
import NoAccess from './no_access';
import NotFound from './not_found';
import NpsResults, {npsResultsQuery} from './internal/nps_results';
import BugDuty, {bugDutyQuery} from './internal/bug_duty';
import OpenTaskModal from './modal/open_task_modal';
import OverviewProjects, {overviewProjectsQuery} from './overview/overview_projects';
import OverviewProjectsV2, {overviewProjectsQueryV2} from './overview/overview_projects_v2';
import PhasesBetaSplitter, {phasesBetaSplitterQuery} from '../components/project-phases/phases_beta_splitter';
import PaymentFailedCompanyStats, {paymentFailedCompanyStatsQuery} from './internal/payment_failed_company_stats';
import ProfileNotificationsSettings, {profileNotificationsSettingsQuery} from './my_profile/profile_notifications_settings';
import ProjectBudgetV2, {projectBudgetV2Query} from './project/project_budget_v2';
import ProjectBudgetV3, {projectBudgetV3Query} from './project/project_budget_v3';
import ProjectClient, {projectClientQuery} from './project/project_client';
import ProjectFiles, {projectFilesQuery} from './project/project_files';
import ProjectGroupConnectedProjects, {
	projectGroupConnectedProjectsQuery,
} from './project_group/project_group_connected_projects';
import ProjectGroupSettingsPage, {ProjectGroupSettingsPageQuery} from './project/project_settings/ProjectGroupSettingsPage';
import ProjectRetainerPeriods, {projectRetainerPeriodsQuery} from './new-ui/project/project_retainer_periods';
import ProjectSettingsPage, {ProjectSettingsPageQuery} from './project/project_settings/ProjectSettingsPage';
import PublicCreateTaskPageOld from './public_create_task_page';
import PublicCreateTaskPage from './PublicCreateTaskPage';
import ResetPassword, {resetPasswordQuery} from './reset_password';
import SettingsAllNotifications, {profileAllNotificationsQuery} from './my_profile/profile_all_notifications';
import SettingsApiKeys, {settingsApiKeysQuery} from './settings/settings_api_keys';
import SettingsAppCatalog, {settingsAppCatalogQuery} from './settings/settings_app_catalog';
import SettingsClient, {settingsClientQuery} from './settings/settings_client';
import SettingsClients, {settingsClientsQuery} from './settings/settings_clients';
import SettingsFinance, {settingsFinanceQuery} from './settings/settings_finance';
import SettingsCompany, {settingsCompanyQuery} from './settings/settings_company';
import SettingsHolidayCalendar, {settingsHolidayCalendarQuery} from './settings/settings_holiday_calendar';
import SettingsHolidayCalendars, {settingsHolidayCalendarsQuery} from './settings/settings_holiday_calendars';
import SettingsIdleTimes, {settingsIdleTimesQuery} from './settings/settings_idle_times';
import SettingsLabels, {settingsLabelsQuery} from './settings/settings_labels';
import SettingsPeople, {settingsPeopleQuery} from './settings/settings_people';
import SettingsProfilePerson, {settingsProfilePersonQuery} from './settings/settings_profile_person';
import SettingsProfileViewer, {settingsProfileViewerQuery} from './settings/settings_profile_viewer';
import SettingsRateCard, {settingsRateCardQuery} from './settings/settings_rate_card';
import SettingsRoles, {settingsRolesQuery} from './settings/settings_roles';
import SettingsSkills, {settingsSkillsQuery} from './settings/skills/settings_skills';
import SettingsSecurity, {profileSecurityQuery} from './my_profile/profile_security';
import SettingsSubscriptionV2, {settingsSubscriptionQuery} from './settings/settings_subscription';
import SettingsTeams, {settingsTeamsQuery} from '../components/settings-teams/settings_teams';
import SettingsDepartments, {settingsDepartmentsQuery} from '../components/settings-departments/settings_departments';
import SharedInsight, {sharedInsightQuery} from './shared_insight';
import Signup, {signupQuery} from './signup';
import TimesheetsPage, {timesheetsPageQuery} from '../forecast-app/my-work-tab/my-timesheets-page/timesheets_page';
import TrialEnd, {trialEndQuery} from './trial_end';
import XeroToken from './xero_token';
import ForecastQueryRenderer from '../ForecastQueryRenderer';
import BuyNowFooter from '../components/buy_now_footer';
import {VersionReloadRoute} from './version_reload_route';
import {versionManager} from '../version_manager';
import CompaniesWithModules, {companiesWithModulesQuery} from './internal/companies_with_modules/companies_with_modules';
import TrialsList, {trialsListQuery} from './internal/trials_list/trials_list';
import InitialPlanPage, {InitialPlanPageQuery} from '../components/initial-plan/InitialPlanPage';
import ProjectWorkflowPage, {ProjectWorkflowPageQuery} from '../forecast-app/project-tab/workflow-page/ProjectWorkflowPage';
import Util from '../forecast-app/shared/util/util';
import {ESTIMATION_UNIT, MODULE_TYPES} from '../constants';
import InvoicingPageV2, {invoicingPageV2Query} from '../components/insights/invoicing/InvoicingPageV2';
import Unit4LogPage, {unit4LogQuery} from '../components/unit4log/Unit4LogPage';
import AdvancedAnalyticsPage, {AdvancedAnalyticsQuery} from '../components/advanced-analytics/AdvancedAnalyticsPage';
import CompaniesToBeDeleted, {companiesToBeDeletedQuery} from './internal/companies_to_be_deleted';
import SettingsCompanyNotifications, {SettingsCompanyNotificationsQuery} from './settings/settings_company_notifications';
import {hasFeatureFlag} from '../forecast-app/shared/util/FeatureUtil';
import ProjectSprintWrapper, {ProjectSprintWrapperQuery} from '../forecast-app/project-tab/sprints-page/ProjectSprintWrapper';
import XeroSignupContainer, {XeroSignupContainerQuery} from './XeroSignupContainer';
import TimeManagementPage, {timeManagementQuery} from '../components/timesheets/TimeManagementPage';
import SettingsProfiles, {settingsProfilesQuery} from './settings/profiles/settings_profiles';
import ProjectScopingPage, {ProjectScopingPageQuerry} from '../forecast-app/project-tab/scoping-page/ProjectScopingPage';
import SalesforceConfigurationConductor, {
	salesforceConfigurationConductorQuery,
} from './settings/app_catalog/SalesforceConfigurationConductor';
import AppHubspot, {appHubspotQuery} from './settings/app_catalog/app_hubspot';
import {CanvasProjectSchedulingShare} from '../components/canvas-scheduling/projects-scheduling/share/CanvasProjectSchedulingShare';
import AppPipedrive, {appPipedriveQuery} from './settings/app_catalog/app_pipedrive';
import ProjectHealthPage, {ProjectHealthPageQuery} from './project/project_health/ProjectHealthPage';

const projectPrefix = end => `/project/P-:projectId(\\d+)/${end}`;

const projectGroupPrefix = end => `/connected/X-:groupId(\\d+)/${end}`;

const sharedPrefix = end => `/shared/:shareUrl/${end}`;

const returnTo = url => () => {
	window.location.href = url;
};

const routerv2 = props => {
	const taskModalRegex = new RegExp('^T\\d+$');
	const appContent = (actualPersonId, availableFeatureFlags, modules, buyNowTime) => {
		const getModuleAuthFunc = moduleType => {
			switch (moduleType) {
				case MODULE_TYPES.FINANCE:
					return () => Util.hasFinance(modules);
				case MODULE_TYPES.RETAINERS:
					return () => Util.shouldUseRetainers(modules);
				case MODULE_TYPES.TIME_LOCKING:
					return () => Util.hasTimeLocking(modules);
				case MODULE_TYPES.DEPARTMENTS:
					return () => Util.hasDepartments(modules);
				case MODULE_TYPES.HUBSPOT:
					return () => Util.hasHubspot(modules);
				default:
					return null;
			}
		};

		// Should the new Scoping page be used as default? - Remove when switching completely!
		const useNewScopingAsDefault = hasFeatureFlag('task_hierarchy_part2', availableFeatureFlags);

		return (
			<div id="app-nav-switch-handle" className="app">
				{/* Header route */}
				<ForecastQueryRenderer
					key="query-render-header"
					query={headerQuery}
					componentName="header"
					variables={{
						majorVersion: versionManager.getClientMajorVersion(),
						minorVersion: versionManager.getClientMinorVersion(),
					}}
					redirectIfNotLoggedIn={true}
					showLoader={true}
					customLoader={e => {
						// render a placeholder for header to avoid content of page jumping
						if (
							window.location.href
								.split('/')
								.some(
									element =>
										(element.includes('global-search') || element.includes('projects')) &&
										!element.includes('scheduling')
								)
						) {
							return <div className={'header-loader'} style={{height: '36px'}}></div>;
						} else {
							return <div className={'header-loader'} style={{height: '71px'}}></div>;
						}
					}}
					render={(relayProps, retry) => {
						return <Header retry={retry} setLocale={props.setLocale} {...relayProps} />;
					}}
				/>

				{/* Switch for all content to only show one page */}
				<Switch>
					{/* region Blocking Pages Section */}
					<Route path="/not-found" component={NotFound} />
					<Route path="/trial-end">
						<ForecastQueryRenderer
							key="query-render-trialEndQuery"
							componentName="trial_end"
							showLoader={true}
							query={trialEndQuery}
							render={relayProps => <TrialEnd {...relayProps} />}
						/>
					</Route>
					<Route path="/access-blocked">
						<ForecastQueryRenderer
							key="query-render-accessBlockedQuery"
							componentName="access_blocked"
							showLoader={true}
							query={accessBlockedQuery}
							render={relayProps => <AccessBlocked {...relayProps} />}
						/>
					</Route>
					<Route path="/not-authorized">
						<NoAccess />
					</Route>
					{/* endregion */}
					{/* region Global Pages Section */}
					<Route path="/global-search">
						<ForecastQueryRenderer
							key="query-render-globalSearch"
							componentName="global_search_results"
							showLoader={true}
							query={globalSearchResultsPageQuery}
							variables={{searchQuery: {}}}
							render={(relayProps, retry) => <GlobalSearchResultsPage {...relayProps} retry={retry} />}
						/>
					</Route>
					{/* endregion */}
					{/* region My List Section */}
					<Route path={['/', '/T:taskId(\\d+)']} exact>
						<ForecastQueryRenderer
							key="query-render-my-work"
							componentName="my_work"
							query={MyWorkPageV2Query}
							showLoader={true}
							variables={{
								personId: actualPersonId,
							}}
							render={(relayProps, retry) => <MyWorkPageV2 retry={retry} {...relayProps} />}
						/>
					</Route>
					<VersionReloadRoute path="/expenses">
						<ForecastQueryRenderer
							key="query-render-myExpenses"
							componentName="my_expenses"
							query={myExpensesQuery}
							showLoader={true}
							authorizeModule={getModuleAuthFunc(MODULE_TYPES.FINANCE)}
							render={(relayProps, retry) => {
								return <MyExpenses setLocale={props.setLocale} {...relayProps} retry={retry} />;
							}}
						/>
					</VersionReloadRoute>
					{/* region Projects Section */}
					<VersionReloadRoute path="/projects">
						<ForecastQueryRenderer
							key="query-render-overviewProjects"
							query={
								hasFeatureFlag('projectOverviewV2FinancialService', availableFeatureFlags)
									? overviewProjectsQueryV2
									: overviewProjectsQuery
							}
							componentName="overview_projects"
							showLoader={true}
							render={(relayProps, retry) => {
								return hasFeatureFlag('projectOverviewV2FinancialService', availableFeatureFlags) ? (
									<OverviewProjectsV2 retry={retry} {...relayProps} buyNowTime={buyNowTime} />
								) : (
									<OverviewProjects retry={retry} {...relayProps} buyNowTime={buyNowTime} />
								);
							}}
						/>
					</VersionReloadRoute>
					{/* endregion */}
					{/* region Time Section */}
					<Route path="/time">
						<Redirect to="/timesheets" />
					</Route>
					<VersionReloadRoute path={'/timesheets'}>
						<ForecastQueryRenderer
							key="query-render-timesheetsPage"
							componentName="timesheet"
							query={timesheetsPageQuery}
							showLoader={true}
							// This is basically initialVariables
							variables={{
								personId: actualPersonId,
								googleTaskId: null,
								pageSize: 15,
								startDateString: Moment().clone().startOf('month').startOf('week').format('YYYY-MM-DD'),
								endDateString: Moment().clone().endOf('month').endOf('week').format('YYYY-MM-DD'),
							}}
							render={(relayProps, retry) => {
								return <TimesheetsPage retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<Route path="/team-time">
						<Redirect to="/time-management" />;
					</Route>
					<Route path="/time-approval">
						<Redirect to="/time-management" />
					</Route>
					<VersionReloadRoute path="/time-management">
						<ForecastQueryRenderer
							key="query-render-time-management"
							componentName="time-management"
							query={timeManagementQuery}
							showLoader={true}
							render={(relayProps, retry) => {
								return (
									<TimeManagementPage
										authFunc={getModuleAuthFunc(MODULE_TYPES.TIME_LOCKING)}
										retry={retry}
										{...relayProps}
									/>
								);
							}}
						/>
					</VersionReloadRoute>
					{/* endregion */}
					{/* region Scheduling Section */}
					<Route exact path="/old-scheduling">
						<Redirect to="/scheduling" />
					</Route>
					<VersionReloadRoute path="/scheduling" component={CanvasScheduling} isProjectTimeline={false} />
					{/* endregion */}
					{/* region Insights Section */}
					<VersionReloadRoute path="/insights" exact>
						<ForecastQueryRenderer
							key="query-render-insightsSection"
							query={insightsSectionQuery}
							componentName="insight_section"
							showLoader={true}
							render={relayProps => {
								return <InsightsSection {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<Route path="/insights/new" component={NewInsightContainer}>
						<ForecastQueryRenderer
							key="query-render-newInsight"
							componentName="new_insight"
							query={newInsightQuery}
							showLoader={true}
							authorizeAccessRoute={'new-report'}
							render={relayProps => {
								return <NewInsightContainer {...relayProps} />;
							}}
						/>
					</Route>
					<Redirect from="/insights/invoicing" to="/invoicing" />
					<VersionReloadRoute path="/insights/financial-portfolio-report">
						<ForecastQueryRenderer
							key="query-render-financialReportPage"
							componentName="financial_report_page"
							query={financialReportPageQuery}
							showLoader={true}
							render={relayProps => {
								return <FinancialReportPage {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<Redirect from="/insights/new-utilisation-report" to="/insights/utilization-report" />
					<Redirect from="/insights/utilization-report" to="/insights" />
					<Route
						path="/insights/:insightId/edit"
						children={({match}) => {
							// Checking if valid id
							try {
								if (!atob(match.params.insightId).startsWith('Insight:')) return <Redirect to="/not-found" />;
							} catch (e) {
								return <Redirect to="/not-found" />;
							}

							return (
								<ForecastQueryRenderer
									key="query-render-insightsBuilderV2"
									componentName="insightsBuilderV2"
									query={insightsBuilderV2Query}
									variables={match.params}
									showLoader={true}
									render={relayProps => {
										if (!relayProps.viewer.company.insight) return <Redirect to="/not-found" />;

										return <InsightsBuilderV2 {...relayProps} />;
									}}
								/>
							);
						}}
					/>
					<VersionReloadRoute
						path="/insights/:insightId"
						children={({match}) => {
							// Router matches to this route even if the path is for the task modal and not an insight. As such, need to check if param is a task modal path before rendering.
							if (match.params && match.params.insightId && !taskModalRegex.test(match.params.insightId)) {
								// Checking if valid id
								try {
									if (!atob(match.params.insightId).startsWith('Insight:'))
										return <Redirect to="/not-found" />;
								} catch (e) {
									return <Redirect to="/not-found" />;
								}

								return (
									<ForecastQueryRenderer
										onlyNetwork={true}
										key="query-render-insightsViewer"
										componentName="insights_viewer"
										query={insightsViewerQuery}
										variables={match.params}
										showLoader={true}
										render={relayProps => {
											return <InsightsViewer {...relayProps} />;
										}}
									/>
								);
							}
						}}
					/>
					<VersionReloadRoute
						path="/saved-report/:savedReportType/:savedReportId"
						children={({match}) => {
							// Router matches to this route even if the path is for the task modal and not an insight. As such, need to check if param is a task modal path before rendering.
							if (
								match.params &&
								match.params.savedReportId &&
								!taskModalRegex.test(match.params.savedReportId)
							) {
								// Checking if valid id
								// try {
								// 	if (!atob(match.params.savedReportId).startsWith('Insight:')) return <Redirect to="/not-found" />;
								// } catch (e) {
								// 	return <Redirect to="/not-found" />;
								// }
								return (
									<ForecastQueryRenderer
										key="query-render-genericSavedReportConductor"
										componentName="generic_saved_report_conductor"
										query={genericSavedReportConductorQuery}
										variables={{savedReportId: match.params.savedReportId}}
										showLoader={true}
										onCloseErrorModal={returnTo('/insights')}
										render={relayProps => {
											return <GenericSavedReportConductor {...relayProps} />;
										}}
									/>
								);
							}
						}}
					/>
					<Route exact path="/saved-report">
						<Redirect to="/insights" />
					</Route>
					{/* endregion */}
					{/* region Project routes */}
					<Redirect exact from={projectPrefix('overview')} to={projectPrefix('settings#status')} />
					<Redirect exact from="/project/P-:projectId(\d+)" to={projectPrefix('workflow')} />
					<VersionReloadRoute
						path={projectPrefix('workflow')}
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key={'query-render-projectWorkflowPage' + match.params.projectId}
									componentName="project_faster_workflow"
									query={ProjectWorkflowPageQuery}
									variables={{
										projectId: match.params.projectId,
									}}
									requireProject={true}
									authorizeAccessRoute={'project-faster-workflow'}
									showLoader={true}
									render={(relayProps, retry) => (
										<ProjectWorkflowPage
											{...relayProps}
											matchProjectId={match.params.projectId}
											retry={retry}
											buyNowTime={buyNowTime}
										/>
									)}
								/>
							);
						}}
					/>
					<VersionReloadRoute
						path={projectPrefix('scoping')}
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key={
										(useNewScopingAsDefault
											? 'query-render-projectPhases-new'
											: 'query-render-projectPhases') + match.params.projectId
									}
									componentName={useNewScopingAsDefault ? 'new_scoping' : 'project_phases'}
									availableFeatureFlags={availableFeatureFlags}
									query={useNewScopingAsDefault ? ProjectScopingPageQuerry : phasesBetaSplitterQuery}
									variables={{...match.params, fetchLazyData: useNewScopingAsDefault}}
									requireProject={true}
									authorizeAccessRoute={'project-phases'}
									showLoader={true}
									render={(relayProps, retry) => {
										return useNewScopingAsDefault ? (
											<ProjectScopingPage {...relayProps} retry={retry} buyNowTime={buyNowTime} />
										) : (
											<PhasesBetaSplitter {...relayProps} retry={retry} buyNowTime={buyNowTime} />
										);
									}}
								/>
							);
						}}
					/>
					{hasFeatureFlag('new_scoping', availableFeatureFlags) && !useNewScopingAsDefault && (
						<VersionReloadRoute
							path={projectPrefix('new-scoping')}
							children={({match}) => {
								return (
									<ForecastQueryRenderer
										key={'query-render-projectPhases-new' + match.params.projectId}
										componentName="new_scoping"
										availableFeatureFlags={availableFeatureFlags}
										query={ProjectScopingPageQuerry}
										variables={{...match.params, fetchLazyData: true}}
										requireProject={true}
										authorizeAccessRoute={'project-phases'}
										showLoader={true}
										render={(relayProps, retry) => {
											return <ProjectScopingPage {...relayProps} retry={retry} buyNowTime={buyNowTime} />;
										}}
									/>
								);
							}}
						/>
					)}
					<VersionReloadRoute
						path={projectPrefix('sprints')}
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key={'query-render-projectSprints' + match.params.projectId}
									componentName="project_sprints_optimized"
									query={ProjectSprintWrapperQuery}
									variables={{...match.params, fetchLazyData: false, onlyActiveSprint: true}}
									requireProject={true}
									authorizeAccessRoute={'project-sprint'}
									showLoader={true}
									render={(relayProps, retry) => {
										return <ProjectSprintWrapper {...relayProps} retry={retry} buyNowTime={buyNowTime} />;
									}}
								/>
							);
						}}
					/>
					<VersionReloadRoute
						path={[projectPrefix('baseline') || projectPrefix('initial-plan')]}
						children={({match}) => (
							<ForecastQueryRenderer
								key={'query-render-projectInitialPlan' + match.params.projectId}
								componentName="project_initial_plan"
								query={InitialPlanPageQuery}
								variables={match.params}
								requireProject={true}
								authorizeAccessRoute={'project-initial-plan'}
								showLoader={true}
								onlyNetwork
								render={(relayProps, retry) => (
									<InitialPlanPage {...relayProps} retry={retry} buyNowTime={buyNowTime} />
								)}
							/>
						)}
					/>
					<VersionReloadRoute
						path={projectPrefix('periods')}
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key={'query-render-projectRetainerPeriods' + match.params.projectId}
									componentName="retainer_periods"
									query={projectRetainerPeriodsQuery}
									variables={match.params}
									requireProject={true}
									authorizeAccessRoute={'project-periods'}
									showLoader={true}
									render={(relayProps, retry) => {
										return <ProjectRetainerPeriods {...relayProps} retry={retry} />;
									}}
								/>
							);
						}}
					/>
					<VersionReloadRoute
						path={projectPrefix('timeline')}
						render={routeProps => <Redirect to={`/project/P-${routeProps.match.params.projectId}/schedule`} />}
					/>
					<VersionReloadRoute
						path={projectPrefix('budget')}
						children={({match}) => {
							return availableFeatureFlags.some(flag => flag.key === 'project_budget_v3') ? (
								<ForecastQueryRenderer
									key={'query-render-projectBudgetV3' + match.params.projectId}
									componentName="project_budget_v3"
									query={projectBudgetV3Query}
									variables={match.params}
									requireProject={true}
									authorizeAccessRoute={'project-budget'}
									showLoader={true}
									render={(relayProps, retry) => {
										return <ProjectBudgetV3 {...relayProps} retry={retry} />;
									}}
								/>
							) : (
								<ForecastQueryRenderer
									key={'query-render-projectBudgetV2' + match.params.projectId}
									componentName="project_budget_v2"
									query={projectBudgetV2Query}
									variables={match.params}
									requireProject={true}
									authorizeAccessRoute={'project-budget'}
									showLoader={true}
									render={(relayProps, retry) => {
										return <ProjectBudgetV2 {...relayProps} retry={retry} />;
									}}
								/>
							);
						}}
					/>
					{hasFeatureFlag('project_health_page', availableFeatureFlags) && (
						<VersionReloadRoute
							path={projectPrefix('nova-insights')}
							children={({match}) => (
								<ForecastQueryRenderer
									key={'query-render-projectHealth' + match.params.projectId}
									componentName="project_health"
									query={ProjectHealthPageQuery}
									variables={match.params}
									requireProject={true}
									authorizeAccessRoute={'project-health'}
									showLoader={true}
									render={(relayProps, retry) => {
										// Not currently supporting points projects or children of connected projects
										if (
											relayProps.viewer.project.projectGroupId ||
											relayProps.viewer.project.estimationUnit === ESTIMATION_UNIT.POINTS
										) {
											return <Redirect to={`/project/P-${match.params.projectId}/workflow`} />;
										}
										return <ProjectHealthPage {...relayProps} retry={retry} />;
									}}
								/>
							)}
						/>
					)}
					<VersionReloadRoute
						path={projectPrefix('schedule')}
						children={({match}) => <CanvasScheduling key={match.params.projectId} isProjectTimeline={true} />}
					/>
					<VersionReloadRoute
						path={projectPrefix('rates')}
						children={({match}) => <Redirect to={`/project/P-${match.params.projectId}/settings#financials`} />}
					/>
					<VersionReloadRoute
						path={projectPrefix('economic')}
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key="query-render-appEconomic"
									componentName="app_economic"
									query={appEconomicQuery}
									variables={match.params}
									showLoader={true}
									authorizeAccessRoute={'settings'}
									render={relayProps => <AppEconomic {...relayProps} />}
								/>
							);
						}}
					/>
					// This routing can be removed after removing all references to it
					<VersionReloadRoute
						path={projectPrefix('team')}
						children={({match}) => <Redirect to={`/project/P-${match.params.projectId}/settings#team`} />}
					/>
					<VersionReloadRoute
						path={projectPrefix('client')}
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key={'query-render-projectClient' + match.params.projectId}
									componentName="project_client"
									query={projectClientQuery}
									variables={match.params}
									requireProject={true}
									authorizeAccessRoute={'project-client'}
									showLoader={true}
									render={relayProps => {
										return <ProjectClient {...relayProps} />;
									}}
								/>
							);
						}}
					/>
					<VersionReloadRoute
						path={projectPrefix('files')}
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key={'query-render-projectFiles' + match.params.projectId}
									componentName="project_files"
									query={projectFilesQuery}
									variables={match.params}
									requireProject={true}
									authorizeAccessRoute={'project-files'}
									showLoader={true}
									render={relayProps => <ProjectFiles {...relayProps} />}
								/>
							);
						}}
					/>
					<VersionReloadRoute
						path={projectPrefix('settings')}
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key={'query-render-projectSettings' + match.params.projectId}
									componentName="project_settings"
									query={ProjectSettingsPageQuery}
									variables={match.params}
									requireProject={true}
									authorizeAccessRoute={'project-settings'}
									showLoader={true}
									render={(relayProps, retry) => {
										return <ProjectSettingsPage {...relayProps} retry={retry} />;
									}}
								/>
							);
						}}
					/>
					<Redirect from={projectPrefix('*')} to={projectPrefix('workflow')} />
					{/* endregion */}
					{/* region Connected project routes */}
					<Redirect exact from={projectGroupPrefix('overview')} to={projectGroupPrefix('group-settings')} />
					<Route
						path="/connected/X-:groupId(\d+)"
						exact
						render={routeProps => <Redirect to={`/connected/X-${routeProps.match.params.groupId}/workflow`} />}
					/>
					<VersionReloadRoute
						path={projectGroupPrefix('workflow')}
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key={'query-render-projectWorkflowPage' + match.params.groupId}
									componentName="project_faster_workflow"
									query={ProjectWorkflowPageQuery}
									variables={{
										groupId: match.params.groupId,
									}}
									requireProject={true}
									authorizeAccessRoute={'project-faster-workflow'}
									showLoader={true}
									render={(relayProps, retry) => (
										<ProjectWorkflowPage
											{...relayProps}
											matchGroupId={match.params.groupId}
											retry={retry}
											buyNowTime={buyNowTime}
										/>
									)}
								/>
							);
						}}
					/>
					<VersionReloadRoute
						path={projectGroupPrefix('schedule')}
						children={({match}) => <CanvasScheduling key={match.params.groupId} isProjectTimeline={true} />}
					/>
					<VersionReloadRoute
						path={projectGroupPrefix('sprints')}
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key={'query-render-projectGroupSprints' + match.params.groupId}
									componentName="project_sprints_optimized"
									query={ProjectSprintWrapperQuery}
									variables={{...match.params, fetchLazyData: false, onlyActiveSprint: true}}
									requireProject={true}
									authorizeAccessRoute={'project-sprint'}
									showLoader={true}
									render={(relayProps, retry) => {
										return <ProjectSprintWrapper {...relayProps} retry={retry} buyNowTime={buyNowTime} />;
									}}
								/>
							);
						}}
					/>
					<VersionReloadRoute
						path={projectGroupPrefix('team')}
						children={({match}) => <Redirect to={`/connected/X-${match.params.groupId}/group-settings#team`} />}
					/>
					<VersionReloadRoute
						path={projectGroupPrefix('connected-projects')}
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key={'query-render-projectGroupProjects' + match.params.groupId}
									componentName="project_group_projects"
									query={projectGroupConnectedProjectsQuery}
									variables={match.params}
									requireProject={true}
									authorizeAccessRoute={'connected-projects'}
									showLoader={true}
									render={relayProps => {
										return <ProjectGroupConnectedProjects {...relayProps} />;
									}}
								/>
							);
						}}
					/>
					<VersionReloadRoute
						path={projectGroupPrefix('group-settings')}
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key={'query-render-projectGroupSettings' + match.params.groupId}
									componentName="project_group_settings"
									query={ProjectGroupSettingsPageQuery}
									variables={match.params}
									requireProject={true}
									authorizeAccessRoute={'group-settings'}
									showLoader={true}
									render={relayProps => {
										return <ProjectGroupSettingsPage {...relayProps} />;
									}}
								/>
							);
						}}
					/>
					<Redirect from={projectGroupPrefix('*')} to={projectGroupPrefix('workflow')} />
					{/* endregion */}
					{/* region portfolio */}
					<VersionReloadRoute path="/invoicing">
						{
							<ForecastQueryRenderer
								key="query-render-invoicingPage"
								componentName="invoicing_page_v2"
								query={invoicingPageV2Query}
								authorizeAccessRoute={'invoicing'}
								showLoader={true}
								render={(relayProps, retry) => {
									return <InvoicingPageV2 {...relayProps} />;
								}}
							/>
						}
					</VersionReloadRoute>
					<VersionReloadRoute path="/unit4log">
						<ForecastQueryRenderer
							key="query-render-unit4Log"
							componentName="unit4_log_page"
							query={unit4LogQuery}
							showLoader={true}
							useModern={true}
							authorizeAccessRoute={'unit4-log'}
							render={(relayProps, retry) => {
								return <Unit4LogPage retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/advanced-analytics">
						<ForecastQueryRenderer
							key="query-render-advanced-analytics"
							componentName="advanced_analytics"
							query={AdvancedAnalyticsQuery}
							showLoader={true}
							useModern={true}
							authorizeAccessRoute={'sisense'}
							render={(relayProps, retry) => {
								return <AdvancedAnalyticsPage retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					{/* endregion */}
					{/* region Admin routes */}
					<VersionReloadRoute exact path="/settings">
						<Redirect to="/settings/details" />
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/details">
						<ForecastQueryRenderer
							key="query-render-settingsCompany"
							componentName="settings_company"
							query={settingsCompanyQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={(relayProps, retry) => {
								return <SettingsCompany retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/team-notifications">
						<ForecastQueryRenderer
							key="query-render-settingsCompanyNotificationsQuery"
							componentName="settings_notifications"
							query={SettingsCompanyNotificationsQuery}
							authorizeAccessRoute={'settings'}
							showLoader={true}
							render={(relayProps, retry) => {
								return <SettingsCompanyNotifications retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/roles">
						<ForecastQueryRenderer
							key="query-render-settingsRoles"
							componentName="settings_roles"
							query={settingsRolesQuery}
							authorizeAccessRoute={'settings'}
							showLoader={true}
							render={(relayProps, retry) => {
								return <SettingsRoles retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/skills">
						<ForecastQueryRenderer
							key="query-render-settingsSkills"
							componentName="settings_skills"
							query={settingsSkillsQuery}
							authorizeAccessRoute={'settings'}
							showLoader={true}
							render={(relayProps, retry) => {
								return <SettingsSkills retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					{hasFeatureFlag('permission_management', availableFeatureFlags) && (
						<VersionReloadRoute path="/settings/profiles">
							<ForecastQueryRenderer
								key="query-render-settingsProfiles"
								componentName="settings_profiles"
								query={settingsProfilesQuery}
								authorizeAccessRoute={'settings'}
								showLoader={true}
								render={(relayProps, retry) => {
									return <SettingsProfiles retry={retry} {...relayProps} />;
								}}
							/>
						</VersionReloadRoute>
					)}
					<VersionReloadRoute path="/settings/labels">
						<ForecastQueryRenderer
							key="query-render-settingsLabels"
							componentName="settings_labels"
							query={settingsLabelsQuery}
							authorizeAccessRoute={'settings'}
							showLoader={true}
							render={(relayProps, retry) => <SettingsLabels retry={retry} {...relayProps} />}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/subscription">
						<ForecastQueryRenderer
							key="query-render-settingsSubscription"
							componentName="settings_subscription"
							query={settingsSubscriptionQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={(relayProps, retry) => {
								if (
									relayProps &&
									relayProps.viewer &&
									relayProps.viewer.company &&
									relayProps.viewer.company.isChargebeeCustomer === false
								) {
									return <Redirect to="/settings/details" />;
								}
								return <SettingsSubscriptionV2 retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/idle-times">
						<ForecastQueryRenderer
							key="query-render-settingsIdleTimes"
							componentName="settings_idle_times"
							query={settingsIdleTimesQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={(relayProps, retry) => {
								return <SettingsIdleTimes retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/people">
						<ForecastQueryRenderer
							key="query-render-settingsPeople"
							componentName="settings_people"
							query={settingsPeopleQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={(relayProps, retry) => {
								return <SettingsPeople retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/teams">
						<ForecastQueryRenderer
							key="query-render-settingsTeams"
							componentName="settings_teams"
							query={settingsTeamsQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={(relayProps, retry) => {
								return <SettingsTeams retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/departments">
						<ForecastQueryRenderer
							key="query-render-settingsDepartments"
							componentName="settings_departments"
							query={settingsDepartmentsQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							authorizeModule={getModuleAuthFunc(MODULE_TYPES.DEPARTMENTS)}
							render={(relayProps, retry) => {
								return <SettingsDepartments retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute
						path="/settings/team/view-user/:userId"
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key="query-render-settingsProfilePerson"
									componentName="settings_profile"
									query={settingsProfilePersonQuery}
									variables={match.params}
									authorizeAccessRoute={'settings'}
									showLoader={true}
									render={(relayProps, retry) => {
										return <SettingsProfilePerson retry={retry} {...relayProps} />;
									}}
								/>
							);
						}}
					/>
					<VersionReloadRoute
						path="/settings/clients/view-client/:clientId"
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key="query-render-settingsClient"
									componentName="settings_client"
									query={settingsClientQuery}
									variables={match.params}
									authorizeAccessRoute={'settings'}
									showLoader={true}
									render={relayProps => {
										return <SettingsClient {...relayProps} />;
									}}
								/>
							);
						}}
					/>
					<VersionReloadRoute path="/settings/clients">
						<ForecastQueryRenderer
							key="query-render-settingsClients"
							componentName="settings_clients"
							query={settingsClientsQuery}
							authorizeAccessRoute={'settings'}
							showLoader={true}
							render={(relayProps, retry) => {
								return <SettingsClients {...relayProps} retry={retry} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute
						path="/settings/rate-cards/view-rate-card/:rateCardId"
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key="query-render-settingsRateCard"
									componentName="settings_rate_card"
									query={settingsRateCardQuery}
									authorizeAccessRoute={'settings'}
									showLoader={true}
									variables={match.params}
									render={(relayProps, retry) => {
										return <SettingsRateCard retry={retry} {...relayProps} />;
									}}
								/>
							);
						}}
					/>
					<VersionReloadRoute
						path="/settings/holiday-calendars/view-holiday-calendar/:holidayCalendarId"
						children={({match}) => {
							return (
								<ForecastQueryRenderer
									key="query-render-settingsHolidayCalendar"
									componentName="settings_holiday_calendar"
									query={settingsHolidayCalendarQuery}
									variables={match.params}
									authorizeAccessRoute={'settings'}
									showLoader={true}
									render={(relayProps, retry) => {
										return <SettingsHolidayCalendar retry={retry} {...relayProps} />;
									}}
								/>
							);
						}}
					/>
					<VersionReloadRoute path="/settings/holiday-calendars">
						<ForecastQueryRenderer
							key="query-render-settingsHolidayCalendars"
							componentName="settings_holiday_calendars"
							query={settingsHolidayCalendarsQuery}
							authorizeAccessRoute={'settings'}
							showLoader={true}
							render={(relayProps, retry) => {
								return <SettingsHolidayCalendars retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/api-keys">
						<ForecastQueryRenderer
							query={settingsApiKeysQuery}
							componentName="settings_api_keys"
							key="query-render-settingsApiKeys"
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={(relayProps, retry) => <SettingsApiKeys retry={retry} {...relayProps} />}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/finance">
						<ForecastQueryRenderer
							key="query-render-settingsFinance"
							componentName="settings_finance"
							query={settingsFinanceQuery}
							authorizeAccessRoute={'settings'}
							authorizeModule={getModuleAuthFunc(MODULE_TYPES.FINANCE)}
							showLoader={true}
							render={(relayProps, retry) => {
								return <SettingsFinance retry={retry} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/harvest">
						<ForecastQueryRenderer
							key="query-render-appHarvest"
							componentName="app_harvest"
							query={appHarvestQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppHarvest {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/asana">
						<ForecastQueryRenderer
							key="query-render-appAsana"
							componentName="app_asana"
							query={appAsanaQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppAsana {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/trello">
						<ForecastQueryRenderer
							key="query-render-appTrello"
							componentName="app_trello"
							query={appTrelloQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppTrello {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/slack">
						<ForecastQueryRenderer
							key="query-render-appCalendar"
							componentName="app_slack"
							query={appSlackQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppSlack {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/github">
						<ForecastQueryRenderer
							key="query-render-appGithub"
							componentName="app_github"
							query={appGithubQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppGithub {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/vsts">
						<ForecastQueryRenderer
							key="query-render-appVstsQuery"
							componentName="app_vsts"
							query={appVstsQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => <AppVsts {...relayProps} />}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/gitlab">
						<ForecastQueryRenderer
							key="query-render-appGitlab"
							componentName="app_gitlab"
							query={appGitlabQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => <AppGitlab {...relayProps} />}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/jira-verified">
						<ForecastQueryRenderer
							key="query-render-appJiraQuery"
							componentName="app_jira"
							query={appJiraQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => <AppJira {...relayProps} showVerifiedPrompt={true} />}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/jira">
						<ForecastQueryRenderer
							key="query-render-appJiraQuery"
							componentName="app_jira"
							query={appJiraQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => <AppJira {...relayProps} />}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/jira-server">
						<ForecastQueryRenderer
							key="query-render-appJiraServerQuery"
							componentName="app_jira_server"
							query={appJiraServerQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => <AppJiraServer {...relayProps} />}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/gdrive">
						<ForecastQueryRenderer
							key="query-render-appGoogleDrive"
							componentName="app_gdrive"
							query={appGoogleDriveQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppGoogleDrive {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/okta">
						<ForecastQueryRenderer
							key="query-render-appOkta"
							componentName="app_okta"
							query={appOktaQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppOkta {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/onelogin">
						<ForecastQueryRenderer
							key="query-render-appOnelogin"
							componentName="app_onelogin"
							query={appOneloginQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppOnelogin {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/azureAD">
						<ForecastQueryRenderer
							key="query-render-appAzureActiveDirectory"
							componentName="app_azure_active_directory"
							query={appAzureActiveDirectoryQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppAzureActiveDirectory {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<Route path="/settings/catalog/gosimplo" component={AppGoSimplo} />
					<VersionReloadRoute path="/settings/catalog/timelog">
						<ForecastQueryRenderer
							key="query-render-appTimeLog"
							componentName="app_timelog"
							query={appTimelogQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppTimeLog {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/xero">
						<ForecastQueryRenderer
							key="query-render-appXero"
							componentName="app_xero"
							query={appXeroQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppXero {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/teams">
						<ForecastQueryRenderer
							key="query-render-appTeams"
							componentName="app_teams"
							query={appTeamsQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppTeams {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/quickbooks">
						<ForecastQueryRenderer
							key="query-render-appQuickbooks"
							componentName="app_quickbooks"
							query={appQuickbooksQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppQuickbooks {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/economic">
						<ForecastQueryRenderer
							key="query-render-appEconomic"
							componentName="app_economic"
							query={appEconomicQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppEconomic {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/salesforce">
						<ForecastQueryRenderer
							key="query-render-salesforceConfigurationConductor"
							componentName="salesforce_configuration_conductor"
							query={salesforceConfigurationConductorQuery}
							showLoader={true}
							//authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <SalesforceConfigurationConductor {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/unit4">
						<ForecastQueryRenderer
							key="query-render-appUnit4"
							componentName="app_unit4"
							query={appUnit4Query}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppUnit4 {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/hubspot">
						<ForecastQueryRenderer
							key="query-render-appHubspot"
							componentName="app_hubspot"
							query={appHubspotQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							authorizeModule={getModuleAuthFunc(MODULE_TYPES.HUBSPOT)}
							render={relayProps => {
								return <AppHubspot {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/pipedrive">
						<ForecastQueryRenderer
							key="query-render-apppipedrive"
							componentName="app_pipedrive"
							query={appPipedriveQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							authorizeModule={getModuleAuthFunc(MODULE_TYPES.PIPEDRIVE)}
							render={relayProps => {
								return <AppPipedrive {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/bamboohr">
						<ForecastQueryRenderer
							key="query-render-appbamboohr"
							componentName="app_bamboohr"
							query={appBambooHRQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							authorizeModule={getModuleAuthFunc(MODULE_TYPES.BAMBOOHR)}
							render={relayProps => {
								return <AppBambooHR {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/settings/catalog/zapier" component={AppZapier} />
					<VersionReloadRoute path="/settings/catalog/calendar">
						<ForecastQueryRenderer
							key="query-render-appCalendar"
							componentName="app_calendar"
							query={appCalendarQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <AppCalendar {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					{/* This needs to be under the other routes to render the list if not in a particular app page */}
					<VersionReloadRoute path="/settings/catalog">
						<ForecastQueryRenderer
							key="query-render-settingsAppCatalog"
							componentName="settings_catalog"
							query={settingsAppCatalogQuery}
							showLoader={true}
							authorizeAccessRoute={'settings'}
							render={relayProps => {
								return <SettingsAppCatalog {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					{/* endregion */}
					{/* region Profile routes */}
					<Route exact path="/my-profile">
						<Redirect to="/my-profile/profile" />
					</Route>
					<VersionReloadRoute path="/my-profile/profile">
						<ForecastQueryRenderer
							key="query-render-settingsProfileViewer"
							componentName="settings_profile"
							query={settingsProfileViewerQuery}
							showLoader={true}
							render={relayProps => {
								return <SettingsProfileViewer setLocale={props.setLocale} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/my-profile/security">
						<ForecastQueryRenderer
							key="query-render-profileSecurity"
							componentName="settings_security"
							query={profileSecurityQuery}
							showLoader={true}
							render={relayProps => {
								return <SettingsSecurity setLocale={props.setLocale} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/my-profile/all-notifications">
						<ForecastQueryRenderer
							key="query-render-profileAllNotifications"
							componentName="profile_all_notifications"
							query={profileAllNotificationsQuery}
							showLoader={true}
							render={relayProps => {
								return <SettingsAllNotifications setLocale={props.setLocale} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/my-profile/notifications">
						<ForecastQueryRenderer
							key="query-render-profileNotificationsSettings"
							componentName="settings_notifications"
							query={profileNotificationsSettingsQuery}
							showLoader={true}
							render={(relayProps, retry) => {
								return (
									<ProfileNotificationsSettings setLocale={props.setLocale} retry={retry} {...relayProps} />
								);
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/my-profile/expenses">
						<ForecastQueryRenderer
							key="query-render-myExpenses"
							componentName="my_expenses"
							query={myExpensesQuery}
							showLoader={true}
							authorizeModule={getModuleAuthFunc(MODULE_TYPES.FINANCE)}
							render={relayProps => {
								return <MyExpenses setLocale={props.setLocale} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					<VersionReloadRoute path="/my-profile/task-activities">
						<ForecastQueryRenderer
							key="query-render-myTaskActivities"
							componentName="my_task_activities"
							query={myTaskActivitiesQuery}
							showLoader={true}
							render={relayProps => {
								return <MyTaskActivities setLocale={props.setLocale} {...relayProps} />;
							}}
						/>
					</VersionReloadRoute>
					{/* endregion */}
					<Redirect to="/not-found" />
				</Switch>

				{/* Task route to always be applied */}
				<Route
					path={['/:pageNo*/T:taskId(\\d+)']}
					render={routeProps => <OpenTaskModal params={routeProps.match.params} />}
				/>
				{buyNowTime ? <BuyNowFooter buyNowTime={buyNowTime} /> : null}
				{process.env.CIRCLE_BRANCH !== 'production' /* && process.env.CIRCLE_BRANCH !== 'master' */ ? (
					<div className={'hubspot-chat'}>
						<span className={'hubspot-chat-inner'} role="img" aria-label="hubspot icon">
							🙈
						</span>
					</div>
				) : null}
			</div>
		);
	};

	const controlUrls = ['/missioncontrol', '/control'];

	return (
		<Switch>
			{/* region Routes where the user is not logged in */}
			<Route
				path="/signup_xero"
				children={() => (
					<ForecastQueryRenderer
						key="query-render-signup-xero"
						query={XeroSignupContainerQuery}
						componentName="signup_xero"
						renderIfNotLoggedIn={true}
						render={relayProps => <XeroSignupContainer {...relayProps} />}
					/>
				)}
			/>
			<Route path="/login">
				<ForecastQueryRenderer
					key="query-render-login"
					componentName="login"
					query={loginQuery}
					renderIfNotLoggedIn={true}
					render={relayProps => <Login {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />}
				/>
			</Route>
			<Route
				path="/signup"
				children={routeProps => {
					if (routeProps.location.search.includes('utm_campaign=Reactivation')) {
						window.location.href = 'https://experience.forecast.it/start-a-new-forecast-trial';
					} else {
						return (
							<ForecastQueryRenderer
								key="query-render-signupQuery"
								componentName="signup"
								query={signupQuery}
								renderIfNotLoggedIn={true}
								render={relayProps => (
									<Signup {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />
								)}
							/>
						);
					}
				}}
			/>
			<Route path="/maintenance">
				<ForecastQueryRenderer
					key="query-render-maintenance"
					componentName="maintenance"
					query={maintenanceQuery}
					renderIfNotLoggedIn={true}
					render={relayProps => <Maintenance {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />}
				/>
			</Route>
			<Route path="/okta-login">
				<ForecastQueryRenderer
					key="query-render-loginOktaQuery"
					componentName="login_okta"
					query={loginOktaQuery}
					renderIfNotLoggedIn={true}
					render={relayProps => <LoginOkta {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />}
				/>
			</Route>
			<Route path="/one-login">
				<ForecastQueryRenderer
					key="query-render-loginOneloginQuery"
					componentName="login_onelogin"
					query={loginOneloginQuery}
					renderIfNotLoggedIn={true}
					render={relayProps => <LoginOnelogin {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />}
				/>
			</Route>
			<Route path="/azureAD">
				<ForecastQueryRenderer
					key="query-render-loginAzureActiveDirectory"
					componentName="login_azure_active_directory"
					query={loginAzureActiveDirectoryQuery}
					renderIfNotLoggedIn={true}
					render={relayProps => (
						<LoginAzureActiveDirectory {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />
					)}
				/>
			</Route>
			<Route path="/xero-token">
				<XeroToken setLocaleFromBrowser={props.setLocaleFromBrowser} />
			</Route>
			<Route path="/salesforce-login">
				<ForecastQueryRenderer
					key="query-render-loginSalesforceQuery"
					componentName="login_salesforce"
					query={loginSalesforceQuery}
					renderIfNotLoggedIn={true}
					render={relayProps => <LoginSalesforce {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />}
				/>
			</Route>
			<Route path="/oauth/authorize">
				<ForecastQueryRenderer
					key="query-render-loginOauthQuery"
					componentName="login_oauth"
					query={loginOauthQuery}
					renderIfNotLoggedIn={true}
					render={relayProps => <LoginOauth {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />}
				/>
			</Route>
			<Route path="/first/:key/:email">
				<ForecastQueryRenderer
					key="query-render-firstLoginQuery"
					componentName="first_login"
					query={firstLoginQuery}
					showLoader={true}
					renderIfNotLoggedIn={true}
					render={relayProps => <FirstLogin {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />}
				/>
			</Route>
			<Route path="/first/:key">
				<ForecastQueryRenderer
					key="query-render-firstLoginQuery"
					componentName="first_login"
					query={firstLoginQuery}
					showLoader={true}
					renderIfNotLoggedIn={true}
					render={relayProps => {
						return <FirstLogin {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />;
					}}
				/>
			</Route>
			<Route path="/registration/:key">
				<ForecastQueryRenderer
					key="query-render-firstLoginV2Query"
					componentName="first_login"
					query={firstLoginV2Query}
					showLoader={true}
					renderIfNotLoggedIn={true}
					render={relayProps => {
						return <FirstLoginV2 {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />;
					}}
				/>
			</Route>
			<Route path="/forgot-password">
				<ForgotPassword setLocaleFromBrowser={props.setLocaleFromBrowser} />
			</Route>
			<Route
				path="/reset/:key"
				children={({match}) => (
					<ForecastQueryRenderer
						key="query-render-resetPasswordQuery"
						componentName="reset_password"
						query={resetPasswordQuery}
						variables={match.params}
						showLoader={true}
						renderIfNotLoggedIn={true}
						render={relayProps => (
							<ResetPassword {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />
						)}
					/>
				)}
			/>
			<Route
				path="/add-task-form/:linkToPublicCreateTaskPage"
				children={({match}) => (
					<PublicCreateTaskPageOld match={match} setLocaleFromBrowser={props.setLocaleFromBrowser} />
				)}
			/>
			<Route
				path="/create-task-form/:linkToPublicCreateTaskPage"
				children={({match}) => <PublicCreateTaskPage match={match} setLocaleFromBrowser={props.setLocaleFromBrowser} />}
			/>

			<Route
				path="/sharedinsight/:shareKey"
				children={({match}) => {
					return (
						<ForecastQueryRenderer
							key="query-render-sharedInsight"
							componentName="shared_insight"
							query={sharedInsightQuery}
							variables={match.params}
							showLoader={true}
							renderIfNotLoggedIn={true}
							render={relayProps => {
								return <SharedInsight {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} />;
							}}
						/>
					);
				}}
			/>

			<Route path="/sisense/sso">
				<ForecastQueryRenderer
					key="query-render-login"
					componentName="login"
					query={loginQuery}
					renderIfNotLoggedIn={true}
					render={relayProps => (
						<Login {...relayProps} setLocaleFromBrowser={props.setLocaleFromBrowser} sisenseLogin={true} />
					)}
				/>
			</Route>
			<Route path="/sisense/ssout" />

			{/* shared timeline */}
			<Route
				path={sharedPrefix('schedule')}
				children={({match}) => <CanvasScheduling key={match.params.shareUrl} isProjectTimeline={true} />}
			/>
			{/* endregion */}
			{/* project scheduling share */}
			<Route exact path="/project-scheduling-share/:shareUrl">
				<CanvasProjectSchedulingShare />
			</Route>
			{/* endregion */}
			{/* region Mission control pages */}
			<Route path={controlUrls}>
				<Route path={controlUrls} exact>
					<ForecastQueryRenderer
						key="query-render-impersonate"
						componentName="control_impersonate"
						query={impersonateQuery}
						showLoader={true}
						render={relayProps => <Impersonate {...relayProps} />}
					/>
				</Route>
				<Route path={controlUrls.map(url => url + '/company-stats')}>
					<ForecastQueryRenderer
						key="query-render-companyStatsQuery"
						componentName="control_company_stats"
						query={companyStatsQuery}
						showLoader={true}
						render={relayProps => <CompanyStats {...relayProps} />}
					/>
				</Route>
				<Route path={controlUrls.map(url => url + '/trials')}>
					<ForecastQueryRenderer
						key="query-render-trialsListQuery"
						componentName="control_trials_list"
						query={trialsListQuery}
						showLoader={true}
						render={(relayProps, retry) => <TrialsList {...relayProps} retry={retry} />}
					/>
				</Route>
				<Route path={controlUrls.map(url => url + '/companies-with-modules')}>
					<ForecastQueryRenderer
						key="query-render-companiesWithModulesQuery"
						componentName="control_companies_with_modules"
						query={companiesWithModulesQuery}
						showLoader={true}
						render={(relayProps, retry) => <CompaniesWithModules {...relayProps} retry={retry} />}
					/>
				</Route>
				<Route path={controlUrls.map(url => url + '/payment-failed-company-stats')}>
					<ForecastQueryRenderer
						key="query-render-paymentFailedCompanyStats"
						componentName="control_payment_failed_company_stats"
						query={paymentFailedCompanyStatsQuery}
						showLoader={true}
						render={relayProps => <PaymentFailedCompanyStats {...relayProps} />}
					/>
				</Route>
				<Route path={controlUrls.map(url => url + '/person-list')}>
					<ForecastQueryRenderer
						key="query-render-controlPersonList"
						componentName="control_person_list"
						query={controlPersonListQuery}
						variables={{searchString: ''}}
						showLoader={true}
						render={relayProps => <ControlPersonList {...relayProps} />}
					/>
				</Route>
				<Route path={controlUrls.map(url => url + '/ml-stats')}>
					<ForecastQueryRenderer
						key="query-render-mlStatsQuery"
						componentName="control_ml_models"
						query={mlStatsQuery}
						showLoader={true}
						render={relayProps => <MLStats {...relayProps} />}
					/>
				</Route>
				<Route path={controlUrls.map(url => url + '/flatfile')}>
					<ForecastQueryRenderer
						key="query-render-FlatfileQuery"
						componentName="flatfile"
						query={FlatfileQuery}
						showLoader={true}
						render={relayProps => <Flatfile {...relayProps} />}
					/>
				</Route>
				<Route path={controlUrls.map(url => url + '/features')}>
					<ForecastQueryRenderer
						key="query-render-featureFlagsQuery"
						componentName="control_feature_flags"
						query={featureFlagsQuery}
						showLoader={true}
						render={relayProps => <FeatureFlags {...relayProps} />}
					/>
				</Route>
				<Route path={controlUrls.map(url => url + '/nps-results')}>
					<ForecastQueryRenderer
						key="query-render-npsResults"
						componentName="control_nps_results"
						query={npsResultsQuery}
						showLoader={true}
						render={relayProps => <NpsResults {...relayProps} />}
					/>
				</Route>
				<Route path={controlUrls.map(url => url + '/bug-duty')}>
					<ForecastQueryRenderer
						key="query-render-bugDutyQuery"
						componentName="control_bug_duty"
						query={bugDutyQuery}
						showLoader={true}
						render={relayProps => <BugDuty {...relayProps} />}
					/>
				</Route>
				<Route path={controlUrls.map(url => url + '/companies_to_be_deleted')}>
					<ForecastQueryRenderer
						key="query-render-companiesToBeDeletedQuery"
						componentName="control_companies_to_be_deleted"
						query={companiesToBeDeletedQuery}
						showLoader={true}
						render={relayProps => <CompaniesToBeDeleted {...relayProps} />}
					/>
				</Route>
			</Route>
			{/* endregion */}
			{/* Logged in routes */}
			<Route path="/">
				<ForecastQueryRenderer
					key="query-render-appv2Query"
					componentName="appv2"
					query={appv2Query}
					showLoader={true}
					redirectIfNotLoggedIn={true}
					render={relayProps => <AppV2 {...relayProps} setLocale={props.setLocale} appContent={appContent} />}
				/>
			</Route>
		</Switch>
	);
};

export default routerv2;
